import { graphql } from "react-relay";

export const DeleteScheduledDigestRunMutation = graphql`
  mutation DeleteScheduledDigestRunMutation($input: DeleteScheduledDigestRunInput!) {
    deleteScheduledDigestRun(input: $input) {
      success
      job {
        id
        name
        schedule
        taskType
        status
      }
    }
  }
`;
